import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import { FormattedMessage, useIntl } from 'react-intl';

import DateAndTimeStamp from '@components/dates/DateAndTimeStamp';
import FileResource from '@components/FileResource';
import SmallLabel from '@components/labels/SmallLabel';
import LargeText from '@components/text/LargeText';
import useSanitizeHtml from '@hooks/useSanitizeHtml';
import { GetMessageQuery } from '@typing/Generated';
import { messagePresentedName } from '@utils/modelUtils';

type Props = {
  message: GetMessageQuery['message'];
};

const AdminMessage = ({ message }: Props) => {
  const intl = useIntl();
  const sanitizedBody = useSanitizeHtml(message.body, '', message);

  return (
    <dl>
      <dt>
        <SmallLabel>
          <FormattedMessage id="models.message.from" />
        </SmallLabel>
      </dt>
      <dd>
        <LargeText>
          <IonText>{messagePresentedName(message, intl)}</IonText>
        </LargeText>
      </dd>

      <dt>
        <SmallLabel>
          <FormattedMessage id="models.message.sender" />
        </SmallLabel>
      </dt>
      <dd>
        <LargeText>
          <FormattedMessage id={`models.message.${message.author.__typename.toLowerCase()}Sender`} />
        </LargeText>
      </dd>

      <dt>
        <SmallLabel>
          <FormattedMessage id="models.message.createdAt" />
        </SmallLabel>
      </dt>
      <dd>
        <LargeText>
          <DateAndTimeStamp value={message.createdAt} />
        </LargeText>
      </dd>

      <dt>
        <SmallLabel>
          <FormattedMessage id="models.message.body" />
        </SmallLabel>
      </dt>
      <dd>{sanitizedBody}</dd>

      <dt>
        <SmallLabel>
          <FormattedMessage id="models.message.attachments" />
        </SmallLabel>
      </dt>
      <dd>
        {message.fileResources.length > 0 && (
          <IonGrid className="ion-no-padding">
            {message.fileResources.map(fileResource => (
              <IonRow className="ion-no-padding" key={fileResource.id}>
                <IonCol className="ion-no-padding ion-padding-bottom">
                  <LargeText>
                    <FileResource fileResource={fileResource} />
                  </LargeText>
                </IonCol>
              </IonRow>
            ))}
          </IonGrid>
        )}
      </dd>
    </dl>
  );
};

export default AdminMessage;
